export interface ITextField {
  id: string;
  label: string;
  placeholder?: string;
  isRequired: boolean;
  isTextArea: boolean;
}

export interface ISignUpFields {
  companyName: string;
  fullName: string;
  title: string;
  email: string;
  phone: string;
  addressLine1: string;
  addressLine2: string;
  addressCity: string;
  addressState: string;
  addressZip: string;
  addressCountry: string;
  customerNames: string;
  integrationDetails: string;
  companyWebsite: string;
  companyDescription: string;
  parentCompanyName: string;
  numberOfDistricts: string;
  statesWorkingIn: string;
  targetAudience: string;
  customerSuccess: string;
  customerBenefits: string;
  skywardBenefits: string;
  systemCommunication: string;
  leadPassOrRevenueShare: string;
  validationCode: string;
}

export const requiredSignUpFields: string[] = [
  "companyName",
  "fullName",
  "title",
  "email",
  "phone",
  "addressLine1",
  "addressCity",
  "addressState",
  "addressZip",
  "addressCountry",
  "customerNames",
  "integrationDetails",
  "companyWebsite",
  "companyDescription",
  "numberOfDistricts",
  "statesWorkingIn",
  "targetAudience",
  "customerSuccess",
  "customerBenefits",
  "skywardBenefits",
  "systemCommunication",
  "leadPassOrRevenueShare",
  "validationCode",
];

export const emptySignUpFields: ISignUpFields = {
  companyName: "",
  fullName: "",
  title: "",
  email: "",
  phone: "",
  addressLine1: "",
  addressLine2: "",
  addressCity: "",
  addressState: "",
  addressZip: "",
  addressCountry: "",
  customerNames: "",
  integrationDetails: "",
  companyWebsite: "",
  companyDescription: "",
  parentCompanyName: "",
  numberOfDistricts: "",
  statesWorkingIn: "",
  targetAudience: "",
  customerSuccess: "",
  customerBenefits: "",
  skywardBenefits: "",
  systemCommunication: "",
  leadPassOrRevenueShare: "",
  validationCode: "",
};

export const ContactInfo: ITextField[] = [
  {
    id: "fullName",
    label: "Full Name",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "title",
    label: "Title",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "email",
    label: "Email Address",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "phone",
    label: "Phone Number",
    isRequired: true,
    isTextArea: false,
  },
];

export const CompanyInfo = [
  {
    id: "companyName",
    label: "Company Name",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "addressLine1",
    label: "Address Line 1",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "addressLine2",
    label: "Address Line 2",
    isRequired: false,
    isTextArea: false,
  },
  {
    id: "addressCity",
    label: "City",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "addressState",
    label: "State",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "addressZip",
    label: "ZIP Code",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "addressCountry",
    label: "Country",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "companyWebsite",
    label: "Website",
    isRequired: true,
    isTextArea: false,
  },
];

export const CompanyBackground: ITextField[] = [
  {
    id: "parentCompanyName",
    label: "Is your company a subsidiary of another company? If so, what is the parent company name?",
    isRequired: false,
    isTextArea: false,
  },
  {
    id: "numberOfDistricts",
    label: "How many districts in the US does your company serve?",
    isRequired: true,
    isTextArea: false,
  },
  {
    id: "companyDescription",
    label: "Briefly describe what your company does.",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "customerNames",
    label: "List the mutual customers your company is working with currently.",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "statesWorkingIn",
    label: "List the states your company is doing business in.",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "targetAudience",
    label: "Describe your company's target audience.",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "customerSuccess",
    label: "Describe your company's success with its customers.",
    placeholder: "e.g., how long you have been in business, how many years you have worked with your most tenured customer",
    isRequired: true,
    isTextArea: true,
  },
];

export const IntegrationDetails: ITextField[] = [
  {
    id: "customerBenefits",
    label: "How will this integration benefit our customers?",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "skywardBenefits",
    label: "How will this integration benefit Skyward, Inc.?",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "systemCommunication",
    label: "Describe how this integration communicates with our system.",
    isRequired: true,
    isTextArea: true,
  },
  {
    id: "leadPassOrRevenueShare",
    label: "Is your company willing to do a lead pass or revenue share?",
    isRequired: true,
    isTextArea: false,
  },
];
